var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 16.0056,
    x2: 16.0056,
    y1: 2,
    y2: 30
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21248,
    stopColor: "#051839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40695,
    stopColor: "#0a1b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    stopColor: "#132e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    stopColor: "#144b7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87279,
    stopColor: "#136497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1387b8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.56967 20.0269c1.73074 5.7695 7.08456 9.9731 13.42093 9.9731 7.7368 0 14.0089-6.2682 14.0089-14 0-7.73197-6.2721-14-14.0089-14-7.42426 0-13.49909 5.77172-13.97888 13.0699 0 2.0968 0 2.9718.55795 4.957z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.2706 12.5629-3.428 4.9766c-.8081-.0367-1.6216.1919-2.29688.6357l-7.52743-3.0968s-.17418 2.8637.5517 4.9979l5.32148 2.1944c.26719 1.1933 1.08632 2.24 2.29483 2.7435 1.9772.8256 4.257-.1154 5.0795-2.0922.2141-.5168.3139-1.0587.2994-1.5995l5.0252-3.5006c2.9353 0 5.321-2.3914 5.321-5.3282 0-2.93697-2.3857-5.32622-5.321-5.32622-2.8351 0-5.4787 2.47378-5.3198 5.39542zm-.8237 10.0154c-.6366 1.5274-2.3929 2.252-3.9196 1.6163-.70428-.2932-1.23602-.8304-1.54278-1.4709l1.73218.7174c1.1259.4687 2.4176-.0649 2.8856-1.1897.4695-1.126-.0631-2.419-1.1884-2.8877l-1.7906-.7415c.6909-.2619 1.4764-.2715 2.2103.0337.7398.3076 1.3139.8869 1.6181 1.6271.3043.7403.3031 1.5574-.0048 2.2953zm6.1435-6.5349c-1.954 0-3.5449-1.5923-3.5449-3.5497 0-1.9558 1.5909-3.54852 3.5449-3.54852 1.9553 0 3.5461 1.59272 3.5461 3.54852 0 1.9574-1.5908 3.5497-3.5461 3.5497zm-2.6563-3.5551c0-1.4724 1.1929-2.66671 2.6623-2.66671 1.4707 0 2.6635 1.19431 2.6635 2.66671 0 1.4726-1.1928 2.6658-2.6635 2.6658-1.4694 0-2.6623-1.1932-2.6623-2.6658z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.95d877f757baeb2efbcdbac03cad1025.svg";
export { ForwardRef as ReactComponent };